import { IDurationOptions } from "@/helper/date/types/duration-options.type";
import { formatDistanceLocale } from "./format-distance-locale.util";
import { defaultDurationOptions } from "@/helper/date/constants/duration.const";

import { formatDuration as fnsFormatDuration, type Duration } from "date-fns";

export const formatDuration = (input: Duration, options: IDurationOptions = defaultDurationOptions) => {
  const { units, format, ...rest } = options;
  const objDistanceLocale = formatDistanceLocale(units);
  const newFormat = [...format];

  if (input.days && input.days > 0) {
    newFormat?.unshift("days");
  }

  if (input.weeks && input.weeks > 0) {
    newFormat?.unshift("weeks", "days");
  }

  if (input.months && input.months > 0) {
    newFormat?.unshift("months", "weeks", "days");
  }

  if (input.years && input.years > 0) {
    newFormat?.unshift("years", "months", "weeks", "days");
  }

  return fnsFormatDuration(input, {
    ...defaultDurationOptions,
    format: Array.from(new Set(newFormat)),
    ...rest,
    locale: {
      formatDistance: (token: string, count) => {
        const formatCount = count < 10 ? `0${count}` : count;
        return objDistanceLocale[token].replace("{{count}}", formatCount);
      },
    },
  });
};
